export default "__VITE_ASSET__o4zYyzPz__"